import { convertFromRaw, convertToRaw, EditorState } from 'draft-js';
import PropTypes from 'prop-types';
import React from 'react';
//import { ENTITY_TYPE } from 'draft-js-utils';
//import { EditorState, Modifier } from 'draft-js';
import 'react-confirm-alert/src/react-confirm-alert.css';
import MathJax from '../component/react-mathjax-preview';
import { Button, Cell, Grid, TextField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import ApiRequestService from '../component/ApiRequestService';
import ImageResizeWarning from '../component/ImageResizeWarning';
import Loader from '../component/Loader';
import LoadingSpinner from '../component/LoadingSpinner';
import TextEditor from '../component/TextEditor';
import '../css/common.css';
import '../css/createExplanations.css'; ///bug-tracker#156
import '../css/custom.css';
import '../css/index.css';
import styles from '../css/styles.css.js';
import { AppSetting } from '../common/function';

//let RichTextEditor = null;
const testString = String.raw`When $a \ne 0$, there are two solutions to \(ax^2 + bx + c = 0\) and they are
$$x = {-b \pm \sqrt{b^2-4ac} \over 2a}.$$`;

//let answerIndex = 0;

export default class CreateHelpMenu extends React.Component {
  AppSetting = AppSetting()

  static propTypes = {
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      HmText: '',
      pageLoading: true,
      math: testString,
      isHmWithPreview: false,
     
      HmName: '',
      loading: true,
      HmNameDefaultVaule: '',
      HmDefaultId: 0,
      HmCatDefaultId: 0,
      hmText: '',
      saveButtonShow: true,
      loadingSave: false,
      altHmTextVisible:false,
      altHmText:'',
      imgTagCount:0,
      instructor_name: window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_OSUID`),
      userprofilerole : parseInt(window.localStorage.getItem(`${this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX}_role`), 10),
      hmCat_id: this.props.selectedHmCatId,
      hmSubCat_id: this.props.selectedHmSubCatId,
      instructorHmAccess : 0,
      editingAccess : false
    };

    this.onHmTextChange = this.onHmTextChange.bind(this);
    this.previewHm = this.previewHm.bind(this);
    this.previewExit = this.previewExit.bind(this);

    this.changeHmName = this.changeHmName.bind(this);
    this.getHelpByID = this.getHelpByID.bind(this);
    this.updateHelpMenu = this.updateHelpMenu.bind(this);
    this.onDisplayStyleChange = this.onDisplayStyleChange.bind(this);

  }

  //bug-tracker#261
  onDisplayStyleChange(value){
    console.log('event',value);
  }


  componentWillMount() {
    console.debug('componentWillMount');
    if(this.state.userprofilerole === 2){
      this.setState({editingAccess : true})
    }else{
      this.getHelpMenuAccess();
    }
    this.getHelpByID();

  }

  getHelpMenuAccess = () =>{
    const payload = {
      instructor_name: this.state.instructor_name
    };
    ApiRequestService({
      method: 'post',
      url: '/getHmAccess',
      data: payload
    }).then(res => {
      if (res.data.data !== null && res.data.data !== undefined) {
        if( res.data.data.instructor_hm_access === 1){
          this.setState({
            instructorHmAccess : res.data.data.instructor_hm_access,
            editingAccess : true
          })
        }else{
          this.setState({
            instructorHmAccess : res.data.data.instructor_hm_access,
            editingAccess : false
          })
        }
      }
    })
  }



  getHelpByID() {
    
    console.debug('getHelpByID ');
    var hm_cat_id = parseInt(this.props.selectedHmCatId, 10);
    var hm_sub_cat_id = parseInt(this.props.selectedHmSubCatId, 10);
    var hm_id = parseInt(this.props.selectedHmId, 10);
    

    const payload = {
     
      hm_id: hm_id,
      hm_cat_id: hm_cat_id,
      hm_sub_cat_id: hm_sub_cat_id
    };
    //console.debug('componentWillMount payload', payload);

    ApiRequestService({
      method: 'post',
      url: '/getHelpMenuById',
      data: payload
    }).then(res=>{
        if (res.data.data !== null) {
            console.debug('IN IF CONDITION = ', res.data.data);
            if(res.data.data.hm_text !== undefined && res.data.data.hm_text !== null && res.data.data.hm_text !== ""){
                console.log("res.data.data.hm_text ",res.data.data.hm_text);
                const contentState = convertFromRaw( JSON.parse( res.data.data.hm_text) );
                console.log("contentState",contentState);
                const serlializedState  = EditorState.createWithContent(contentState);
                console.log("editorstate ",serlializedState)
        
                this.setState({
                HmNameDefaultVaule: res.data.data.hm_name,
                HmName: res.data.data.hm_name,
                HmDefaultId: parseInt(res.data.data.hm_id, 10),
                HmCatDefaultId: parseInt(res.data.data.hm_cat_id, 10),
                altHmTextEditorObj: res.data.data.hm_alt_text,
                HmTextEditorObj: serlializedState,
                pageLoading: false,
                loading: false,
                });
            } else{
                this.setState({
                  loading: false,
                  HmNameDefaultVaule: res.data.data.hm_name,
                  HmTextEditorObj: TextEditor.createEmptyValue(),
                  altHmTextEditorObj: "",
                  pageLoading: false
                });
              }
        }
    }).catch(err =>{
        console.error('ERROR : ', err);
        NotificationManager.error(err, 'ERROR', 3000);
        this.setState({ loading: false,
        pageLoading: false });
      
    });


  }

  onHmTextChange = value => {
    this.setState({ HmTextEditorObj: value });
    
    let enteredString = TextEditor.getHTMLStringFromEditorState(value);
    console.debug("entered string ",enteredString.toString());
    if (enteredString !== null) {
      this.setState({ HmText: enteredString });
    }
    console.debug(enteredString)
    var imgTagCount = enteredString.split('<img ').length-1
    console.debug(imgTagCount)
    if(imgTagCount >= 1){
      this.setState({
        altHmTextVisible : true,
        imgTagCount : imgTagCount
      })
    }
    if(imgTagCount < 1){
      this.setState({
        altHmTextVisible : false,
        //altHmTextEditorObj :'',
        imgTagCount : imgTagCount
      })
    }
    
  };


  onAltHmTextChange = value => {
    this.setState({ altHmTextEditorObj: value });
    console.debug("value =  ", value);
    let enteredString = this.state.altHmTextEditorObj
    console.debug(enteredString);
    if (enteredString !== null) {
      this.setState({ altHmText: enteredString });
    }
  };




  previewHm() {
    var isHmWithPreview = true;
    this.setState({ isHmWithPreview: isHmWithPreview });
  }
  previewExit() {
    var isHmWithPreview = false;
    this.setState({ isHmWithPreview: isHmWithPreview });
  }

  

  updateHelpMenu(HmID, HmCatID,close) {
    //Validate explanation Name as well.
    var HmName = this.state.HmNameDefaultVaule;
    if (
      HmName === undefined ||
      HmName === null ||
      HmName === '' ||
      HmName === 0
    ) {
      NotificationManager.error(
        ' Name cannot be Empty, please enter a valid  Name'
      );
      return false;
    }
    let tempExplanationText = TextEditor.getHTMLStringFromEditorState(this.state.HmTextEditorObj);
    if (
      (HmName === '' &&
      tempExplanationText === '') ||
      tempExplanationText === '<p><br></p>'
    ) {
      alert('Please enter the vaild  text');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }

    //checking alt  text
    console.debug("imgcount ",this.state.imgTagCount,this.state.altHmTextEditorObj)
    if(this.state.imgTagCount >= 1){
      let tempaltHmTextEditorObj = this.state.altHmTextEditorObj
      tempaltHmTextEditorObj = tempaltHmTextEditorObj.replace(/\n/ig, '')
      tempaltHmTextEditorObj = tempaltHmTextEditorObj.replace(/ /g,'')
      let attrTextArr = tempaltHmTextEditorObj.split(';')
      //removing empty array
      attrTextArr = attrTextArr.filter(function (el) {
        return el !== "";
      });
      console.debug(attrTextArr)
      var attrTextCount = attrTextArr.length
     console.debug(tempaltHmTextEditorObj," ",(attrTextCount%2)," ",this.state.imgTagCount," === ",(attrTextCount/2),"  ",attrTextCount)
      if(tempaltHmTextEditorObj === ''){
      alert('"Title and Alternative Text for all Images" is Empty. Please enter a valid text.');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }
    if((attrTextCount%2) !== 0){
      alert('Title or Alternative text is missing in "Title and Alternative Text for all Images"');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }

    if(this.state.imgTagCount !== (attrTextCount/2)){
      alert('Please enter a valid text for all images in "Title and Alternative Text for all Images"');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }
    var lastChar = tempaltHmTextEditorObj[tempaltHmTextEditorObj.length -1];
    console.debug("last char ",lastChar)
    if(lastChar === ";"){
      alert('Please remove semicolon at the end of the text in "Title and Alternative Text for all Images"');
      this.setState({
        loading: false,
        saveButtonShow: true,
        loadingSave: false
      });
      return false;
    }
  }
    this.setState({
      //loading: true,
      saveButtonShow: false,
      loadingSave: false
    });

    //this.setState({ loading: true })

    console.debug('add Hm :');
    var hm_cat_id =  HmCatID;
    var hm_id = HmID;


    console.debug('add  hm_cat_id =', hm_cat_id);
    console.debug('add  hm_id =', hm_id);
    var Hm_Name = '';
    if (this.state.HmName !== '') {
      Hm_Name = this.state.HmName;
    } else {
      Hm_Name = this.state.HmNameDefaultVaule;
    }


    var hm_text = TextEditor.getHTMLStringFromEditorState(this.state.HmTextEditorObj);
    this.setState(
      {
        hmText : hm_text,
        altHmText : this.state.altHmTextEditorObj
      }
    );
//console.debug("this is before rawdata ",hm_text)
    const rawDraftContentState = JSON.stringify(convertToRaw(this.state.HmTextEditorObj.getCurrentContent()));
//console.debug("this is rawdata ",rawDraftContentState)
    const payload = {
        hm_id: this.props.selectedHmId,
      hm_cat_id: parseInt(this.props.selectedHmCatId, 10),
      hm_sub_cat_id: parseInt(this.props.selectedHmSubCatId, 10),
      hm_name: Hm_Name,
      hm_text: rawDraftContentState,
      hm_alt_text : this.state.altHmTextEditorObj
    };
    this.setState({
      HmID: HmID,
      loadingSave: true
    });
    console.debug('payload', payload);
    ApiRequestService({
      method: 'post',
      url: '/updateHelpMenu',
      data: payload
    }).then(res => {
      console.debug(' updateHelpMenu Response : ', res);
      this.setState({ loadingSave: false });
   
      NotificationManager.success('Saved successfully!', 'Success');
  
    });
    if(close === true){
      this.props.close(payload);
    }
  }

 
  changeHmName(e) {
    //console.debug("changeHmName",e.target.value);
    var tempHmName = e.target.value;
    this.setState({
      HmName: tempHmName,
      HmNameDefaultVaule: tempHmName
    });
  }


  render() {
    if (this.state.pageLoading) {
      return <LoadingSpinner />;
    }

    let HmWithOutPreviewStyle = {
      float: 'left',
      width: '100%',
      marginLeft: '17',

    };
    let floatFooter = {
      position: 'fixed',
      bottom: '0px',
      width: '100%',
      backgroundColor: 'white',
      float: 'left',
    };
    let HmWithPreviewStyle = {
      width: '50%',
      overflow: 'scroll',
      maxHeight: '90vh',
      marginLeft: '17px'
    };
    let HmWithPreviewWidthStyle = { padding: '0px', marginTop: '35px' };
    let HmWithPreviewSaveBtn = { width: '50%' };
    let showPreviewStyle = {
      float: 'right',
      marginTop: '0px',
      //marginLeft: '623px',
      display: 'block',
      //position: 'absolute',
      //backgroundColor: 'rgb(242, 243, 244)',
      height: '100vh',
      width: '45%',
      overflow: 'scroll'
    };
    let hidePreviewStyle = {
      float: 'left',
      marginTop: '-0px',
      marginLeft: '750px',
      display: 'none'
    };
    
    let paddingZero = { paddingLeft: '0px' };

    let hideDiv = { display: 'none' };

    let HmTextWidth = {};

  

    const loadingSave = this.state.loadingSave;
    return (
      <div style={{ width: '100%', overflowY: 'hidden', overflowX: 'hidden' }}>
        <Loader loading={this.state.loading} />
        {this.state.editingAccess ? (
        <div style={styles.createQuesPage}>
          {/*Live Preview Div start*/}
          <div
            style={
              this.state.isHmWithPreview
                ? showPreviewStyle
                : hidePreviewStyle
            }
          >
            <div style={styles.livePreviewTitleDiv}>
              <p style={styles.previewTitle}>Live Preview</p>
              <p style={{ float: 'right' }}>
                <Button
                  flat
                  primary
                  swapTheming
                  style={styles.buttomClass}
                  onClick={this.previewExit}
                >
                  Exit
                </Button>
              </p>
            </div>
            <div style={styles.livePreviewExplanationDiv}>
              {/* <p style={styles.previewTitle}>explanation</p> */}
              <br />
              <br />
              <div style={styles.previewText}>
                  <label >{this.state.HmNameDefaultVaule}</label>
                <MathJax
                  math={TextEditor.getHTMLStringFromEditorState(this.state.HmTextEditorObj)}
                />
              </div>
            </div>
            <div>
              <br />

              <div style={styles.previewText}>

              </div>
            </div>
          </div>
          {/*Live Preview Div end */}
          <div
            style={
              this.state.isHmWithPreview
                ? HmWithPreviewStyle
                : HmWithOutPreviewStyle
            }
          >
            <h1>Help Explanation</h1>

            <div style={{ marginLeft: '17px' }}>
              <b>Help Name</b>
            </div>
            <br />
            <input
              className="textbox-beautify"
              type="text"
              value={this.state.HmNameDefaultVaule}
              onChange={this.changeHmName}
              placeholder="Add New  Name"
            />
            <Button
              flat
              primary
              swapTheming
              style={
                this.state.isHmWithPreview ? hideDiv : styles.livePreview
              }
              onClick={this.previewHm}
            >
              Live Preview
            </Button>

           
            <div style={{ width: '100%' }}>
              <Grid >
                <Cell size={this.state.isHmWithPreview ? 12 : 12}>
                  <div
                    style={
                      this.state.isHmWithPreview
                        ? HmTextWidth
                        : paddingZero
                    }
                  >
                    <TextEditor
                      value={this.state.HmTextEditorObj}
                      onChange={this.onHmTextChange}
                      name='HmEditor'
                      video = "true"
                    /><br/>
                    <div     style={(this.state.altHmTextVisible ?{width : "63%", marginLeft: "5%"} : {display:"none"})}>
                <tr><td><p style={{fontSize:"medium",color: '#960000'}}><label for="altHmId">
                  Title and Alternative Text for all Images </label></p></td>
                <td><Button className='nocqcStyle' icon tooltipLabel="Format : Title Text for 1st Image ; Alt text 1st Image ; Title Text for 2nd Image ; Alt text for 2nd Image and so on. Don't use semicolon at the end of the text. Use it only to separate Title and Alt Text.">help</Button></td></tr>
               
                <TextField
                id="altHmId"
                style={ {borderStyle: "ridge"}}
                rows={2}
                value={this.state.altHmTextEditorObj}
                onChange={this.onAltHmTextChange}
                name='altQuestionEditor'
                />
                </div>
                  </div>
                </Cell><br/>
                <Cell>
               
                </Cell>
              </Grid>

            </div>

            <div
              style={
                this.state.isHmWithPreview
                  ? HmWithPreviewWidthStyle
                  : HmWithOutPreviewStyle
              }
            >
              {/*Answers list div*/}
              <br />

              <ImageResizeWarning />

            </div>
          </div>

          <div
            style={
              this.state.isHmWithPreview
                ? HmWithPreviewSaveBtn
                : HmWithOutPreviewStyle
            }
          >


          <div style = {floatFooter}>

            <center>
              {/* bug id 145  fixes*/}
              {loadingSave ? (
                <LoadingSpinner cls="" />
              ) : (
                <div>
                  <Button
                  style={this.state.editingAccess ? {}:{display:"none"}}

                    flat
                    primary
                    swapTheming
                    onClick={() =>
                            this.updateHelpMenu(
                              this.props.selectedHmId,
                              this.props.selectedHmCatId,
                              false
                              )
                    }
                  >
                    Save
                  </Button>
&nbsp;&nbsp;&nbsp;
                  <Button
                  style={this.state.editingAccess ? {backgroundColor: "green",color: "white"}:{display:"none"}}
                    flat
                    tertiary = "true"
                    swapTheming
                    onClick={() =>
                        this.updateHelpMenu(
                            this.props.selectedHmId,
                            this.props.selectedHmCatId,
                            true
                            )
                    }
                  >
                    Save & Close
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button flat secondary swapTheming onClick={this.props.close}>
                    Close
                  </Button>

                </div>
              )}

            </center>

            </div>
          </div>
        </div>
        ):(
            <div style={styles.livePreviewExplanationDiv}>
              <center>
              <br />
              <br />
              <div style={styles.previewText}>
                  <h2 >{this.state.HmNameDefaultVaule}</h2>
                <MathJax
                  math={TextEditor.getHTMLStringFromEditorState(this.state.HmTextEditorObj)}
                />
              </div>
              
              <div style = {floatFooter}>
              <Button flat secondary swapTheming onClick={this.props.close}>
                    Close
                  </Button>

                </div>
                </center>
            </div>
        )}
      </div>
    );
  }
}
